import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  NgZone,
  NgModule,
  platformCore,
  AfterViewInit
} from "@angular/core";
import { AngularFireList } from "angularfire2/database";
import { AuthService } from "../../core/auth.service";
import { UploadService } from "../../storage/uploads/shared/upload.service";
import { Upload } from "../../storage/uploads/shared/upload";
import { Observable } from "rxjs/Observable";
import * as _ from "lodash";
import { FireBaseService } from "../../services/firebase.service";
import { CamperVan } from "../../models/campervan";
import { AgmSnazzyInfoWindow } from "@agm/snazzy-info-window/directives/snazzy-info-window";
import { FormControl } from "@angular/forms";
import { Router, ActivatedRoute, Params, ParamMap} from '@angular/router';


import {} from "googlemaps";
import { MapsAPILoader } from "@agm/core";
import {} from "@types/googlemaps";

@Component({
  selector: "app-userprofile",
  templateUrl: "./userprofile.component.html",
  styleUrls: ["./userprofile.component.css"]
})
export class UserprofileComponent implements OnInit, AfterViewInit {
  uploads: Observable<any> | AngularFireList<any>;
  selectedFiles: FileList;
  currentUpload: Upload;
  file: File;
  imageRef: any;
  campervan: CamperVan;
  vanlifing: false;

  mySwitch: boolean;

  editState: boolean = false;
  changePic: boolean = false;
  myUserId: string = "";
  updateUserBio: boolean = false;

  updateLocToggle = false;
  id: string;
  user: any;
  // Zoom Level
  //zoom = 4;
  // setting Default Locations
  //lat = 51.678418;
  //lng = 7.809007;

  //@ViewChild("search") public searchElementRef: ElementRef;
  private searchElementRef: ElementRef;
  @ViewChild("search")
  set content(content: ElementRef) {
    this.searchElementRef = content;
  }

  lat: number = 51.678418;
  lng: number = 7.809007;

  public latitude: number;
  public longitude: number;
  public searchControl: FormControl;
  public zoom: number;

  data: object = {
    location: {
      lat: "",
      lng: ""
    },
    adress_components: {},
    formatted_address: "",
    plade_id: "",
    url: ""
  };

  public mapStyle = [
    {
      featureType: "administrative",
      elementType: "labels.text.fill",
      stylers: [
        {
          color: "#444444"
        }
      ]
    },
    {
      featureType: "landscape",
      elementType: "all",
      stylers: [
        {
          color: "#f2f2f2"
        }
      ]
    },
    {
      featureType: "poi",
      elementType: "all",
      stylers: [
        {
          visibility: "off"
        }
      ]
    },
    {
      featureType: "road",
      elementType: "all",
      stylers: [
        {
          saturation: -100
        },
        {
          lightness: 45
        }
      ]
    },
    {
      featureType: "road.highway",
      elementType: "all",
      stylers: [
        {
          visibility: "simplified"
        }
      ]
    },
    {
      featureType: "road.arterial",
      elementType: "labels.icon",
      stylers: [
        {
          visibility: "off"
        }
      ]
    },
    {
      featureType: "transit",
      elementType: "all",
      stylers: [
        {
          visibility: "off"
        }
      ]
    },
    {
      featureType: "water",
      elementType: "all",
      stylers: [
        {
          color: "#46bcec"
        },
        {
          visibility: "on"
        }
      ]
    }
  ];

  constructor(
    public auth: AuthService,
    private uploadService: UploadService,
    private firebaseService: FireBaseService,
    private mapsAPILoader: MapsAPILoader,
    private ngZone: NgZone,
    private router: Router,
    private route: ActivatedRoute
  ) {
    this.myUserId = auth.getUserId();
    console.log(this.myUserId);
  }

  ngAfterViewInit() {
    console.log("After Init");
  }

  ngOnInit() {
    /*console.log(this.auth.userId);
      this.imageRef = this.firebaseService.getCamperVanByUserId(this.auth.userId);
      console.log(this.imageRef);
      */

     this.route.paramMap.subscribe((params: ParamMap) => {
      this.id = params.get('id');
      console.log(this.id);

      this.init();
  });
}

init() {
  this.firebaseService.getUserDetails(this.id).valueChanges().subscribe(user => {
    this.user = user;
    console.log(this.user);
  });

    this.firebaseService
      .getCamperVanByUserId(this.auth.userId)
      .valueChanges()
      .subscribe(campervan => {
        this.campervan = campervan[0];
        this.mySwitch = this.campervan.ontheroad;

        console.log(this.campervan);

        setTimeout(() => {
          this.loadAutocomplete();
        }, 0);
      });

    this.searchControl = new FormControl();
  }

  private setCurrentPosition() {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(position => {
        this.latitude = position.coords.latitude;
        this.longitude = position.coords.longitude;
        this.zoom = 10;
      });
    }
  }

  loadAutocomplete() {
    this.lat = 51.678418;
    this.lng = 7.809007;

    //create search FormControl
    //this.searchControl = new FormControl();

    //set current position
    this.setCurrentPosition();

    console.log("search element ref", this.searchElementRef);

    //load Places Autocomplete
    this.mapsAPILoader.load().then(() => {
      console.log(
        "search element ref after THEN ",
        this.searchElementRef.nativeElement
      );
      let autocomplete = new google.maps.places.Autocomplete(
        this.searchElementRef.nativeElement,
        {
          types: ["address"]
        }
      );
      autocomplete.addListener("place_changed", () => {
        this.ngZone.run(() => {
          //get the place result
          let place: google.maps.places.PlaceResult = autocomplete.getPlace();

          //verify result
          if (place.geometry === undefined || place.geometry === null) {
            return;
          }

          console.log(place);
          //set latitude, longitude and zoom
          this.latitude = place.geometry.location.lat();
          this.longitude = place.geometry.location.lng();
          this.zoom = 12;

          this.campervan.location = {
            lat: place.geometry.location.lat(),
            lng: place.geometry.location.lng()
          };

          this.data = {
            location: {
              lat: this.latitude,
              lng: this.longitude
            },
            adress_components: place.address_components,
            formatted_address: place.formatted_address,
            plade_id: place.id,
            url: place.url
          };

          console.log(this.data);
        });
      });
    });
  }

  logMyUserId(userId) {
    console.log(userId);
  }

  switchChange(campervan) {
    if (this.mySwitch === false) {
      console.log(true);
      campervan.ontheroad = true;
    } else {
      console.log(false);
      campervan.ontheroad = false;
    }

    console.log(campervan);
    this.firebaseService.updateCamperVan(campervan);
  }

  updateCamperVan(event, campervan: CamperVan) {
    if (this.editState) {
      this.editState = false;
    } else {
      this.editState = true;
    }
    console.log(campervan);
    this.firebaseService.updateCamperVan(campervan);
  }

  changeEditState() {
    if (this.editState) {
      this.editState = false;
    } else {
      this.editState = true;
    }
  }

  changePicture() {
    if (this.changePic) {
      this.changePic = false;
    } else {
      this.changePic = true;
    }
  }

  changeBio() {
    if (this.updateUserBio) {
      this.updateUserBio = false;
    } else {
      this.updateUserBio = true;
    }
  }

  detectFiles($event: Event) {
    this.selectedFiles = ($event.target as HTMLInputElement).files;
  }

  uploadSingle(campervan, uid) {
    const file = this.selectedFiles;
    console.log(campervan);
    if (file && file.length === 1) {
      this.currentUpload = new Upload(file.item(0));
      this.uploadService.pushUpload(this.currentUpload, uid, campervan);
      this.changePic = false;
    } else {
      console.error("No File Found!");
    }
  }

  updateLocation(campervan) {
    campervan.location = {
      lat: this.latitude,
      lng: this.longitude
    };

    campervan.locationData = this.data;

    console.log(campervan);
    this.firebaseService.updateCamperVan(campervan);
  }

  mapClicked($event: any) {
    console.log("Map Clicked", $event);
    console.log($event.coords.lat);
    console.log($event.coords.lng);
    this.campervan.location[0] = $event.coords.lat;
    this.campervan.location[1] = $event.coords.lng;
  }

  changeUserBio(userId, userBio) {
    console.log(userId, userBio);
    this.firebaseService.updateUserBio(userId, userBio);
    this.updateUserBio = !this.updateUserBio;
  }
}



// WEBPACK FOOTER //
// /Users/akirchhoff/Documents/Development/loveyourcamper-app/src/app/components/userprofile/userprofile.component.ts